import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import UsersListLayer from "../../../components/crm/UsersListLayer";


const UserList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Users Grid" />

        {/* UsersGridLayer */}
        <UsersListLayer />

      </MasterLayout>

    </>
  );
};

export default UserList;
